import EntityTable from "@mirage/components/entityTable/EntityTable";
import { TrackedApplicationService } from "@publicPortal/services/TrackedApplicationService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { Filter, FilterItem } from "@shared/mirage/entityTable/Filter";
import { UserService } from "@publicPortal/services/UserService";
import React, { useCallback, useState } from "react";
import TrackedAppTableColumns from "./TrackedAppTableColumns";
import { IUser } from "@shared/mirage/core/contracts/IUser";

const trackedAppService = new TrackedApplicationService();

const TrackedApplicationsTab = () => {
    const user: Partial<IUser> = UserService.getLoggedInUser();
    const [rowDeleted, setRowDeleted] = useState(false);
    const onPageRequest = useCallback(async (pageRequest: IEntityPageRequest) => {
        const response = await trackedAppService.pageRequest(pageRequest);
        return response;
    }, []);

    return (
        <>
            <EntityTable
                title="Tracked Applications"
                key="tracked-applications-entityTable"
                stateKey="tracked-applications-entityTable"
                onPageRequest={onPageRequest}
                columns={TrackedAppTableColumns(setRowDeleted)}
                filter={getFilter()}
                forceFetch={rowDeleted}
                isRowSelectable={() => false}
            />
        </>
    );

    function getFilter() {
        const filter = { parts: [] } as Filter;
        const filterItems: FilterItem[] = [{ columnName: "userId", value: user?.id, operator: "=" }];

        filter.parts.push({ filterItems });
        return filter;
    }
};

export default TrackedApplicationsTab;
